export const HourlyRateModels = {
  Calculated: 'Calculated',
  Allocated: 'Allocated',
} as const;
export type HourlyRateModel =
  (typeof HourlyRateModels)[keyof typeof HourlyRateModels];

export const ProjectTaskStatuses = {
  NotStarted: 'NotStarted',
  InProgress: 'InProgress',
  OnHold: 'OnHold',
  Completed: 'Completed',
  Cancelled: 'Cancelled',
} as const;
export type ProjectTaskStatus =
  (typeof ProjectTaskStatuses)[keyof typeof ProjectTaskStatuses];

export const TaskBillingTypes = {
  FixedPriceProject: 'FixedPriceProject',
  FixedPriceTask: 'FixedPriceTask',
  TimeAndMaterial: 'TimeAndMaterial',
} as const;
export type TaskBillingType =
  (typeof TaskBillingTypes)[keyof typeof TaskBillingTypes];

export const BillingMethods = {
  None: 'None',
  TimeMaterial: 'TimeMaterial',
  FixedPrice: 'FixedPrice',
  CostPlus: 'CostPlus',
  Retainer: 'Retainer',
  MilestoneBilling: 'MilestoneBilling',
  PrepaidHours: 'PrepaidHours',
  MinimumRetainer: 'MinimumRetainer',
  TimeMaterialMax: 'TimeMaterialMax',
  OnAccountPayment: 'OnAccountPayment',
} as const;
export type BillingMethod =
  (typeof BillingMethods)[keyof typeof BillingMethods];

export interface CreateProjectPayload {
  name: string;
  isInternalProject: boolean;
  customerId?: number;
  billingMethod?: string | null;
  currencyId?: number;
  priceListId?: number;
}

export interface TaskItem {
  actualHours: number;
  billingMethod: BillingMethod;
  billingType: TaskBillingType;
  budgetAmount: number;
  budgetHours: number;
  contractName: string;
  description: string;
  endDate: string;
  hasAllocations: boolean;
  hourlyRate: number;
  hourlyRateModel: HourlyRateModel;
  isActive: number;
  isBillable: boolean;
  isDefaultBillable: boolean;
  isFixedPrice: boolean;
  isParent: boolean;
  name: string;
  parentTaskId: number | null;
  projectId: number;
  revenueAmount: number;
  sortOrder: number;
  startDate: string;
  status: ProjectTaskStatus;
  taskFullName: string;
  taskId: number;
  taskNo: string;
  taskTypeId: number;
  wbs: string;
  wbsLevel: string;
}

export interface TaskNode {
  task: TaskItem;
  children: TaskNode[];
}

export interface ProjectResponse {
  id: number;
  name: string;
  isInternalProject: boolean;
  customerId: number;
  projectNo: string;
  projectManagerId: number;
  projectTypeId: number;
  activeState: number;
  description: string;
  probabilityRate: number;
  departmentId: number;
  accountManagerId: number;
  projectCategoryId: number;
  isDefaultBillable: number;
  timeRegistrationModel: number;
  status: number;
  currencyId: number;
  legalEntityId: number;
  contactId: number;
  partnerEmployeeId: number;
  tasks: TaskNode[];
}

export interface CreateProjectResponse {
  id: number;
  name: string;
}

export interface MoveTaskPayload {
  newParentId: number | null;
  afterTaskId: number | null;
}

export interface ProjectDetailsResponse {
  currencyCode: string | null;
  factor: number;
  factorColor: 'green' | 'yellow' | 'red' | null;
  hoursBudget: number;
  realizedHours: number;
  allocatedHours: number;
  plannedHours: number;
  revenueBudget: number;
  realizedRevenue: number;
  plannedRevenue: number;
  resourcePlannerWorkItemCount: number;
}
